import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Helmet } from 'react-helmet';
import Banner from '../assets/images/AboutUs/Banner.webp';
// Resources Images
// import Sample3 from '/images/Resources/sample-3.jpg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const resources = [
    { type: 'pdf', filepath: '/images/Resources/Countering Transnational Repression Targeting Pakistani American Pro-Democracy Advocates.pdf', title: 'Countering Transnational Repression Targeting Pakistani American Pro-Democracy Advocates', thumbnail: "/images/Resources/Countering Transnational Repression Targeting Pakistani.png", date: "23 Jun 2025" },
    { type: 'pdf', filepath: '/images/Resources/Introduction to Pakistan for U.S. Policymakers.pdf', title: 'Introduction to Pakistan for U.S. Policymakers', thumbnail: "/images/Resources/Introduction to Pakistan for U.S. Policymakers.png", date: "12 Apr 2025" },
    { type: 'pdf', filepath: '/images/Resources/Short Report- Islamabad Massacre (November 26, 2024).pdf', title: 'Short Report: Islamabad Massacre', thumbnail: "/images/Resources/Short Report- Islamabad Massacre (November 26, 2024).png", date: "Mar 2025" },


    { type: 'pdf', filepath: '/images/Resources/Letter of Support for the Pakistan Democracy Act.pdf', title: 'Strong Support for the Pakistan Democracy Act', thumbnail: "/images/Resources/Letter of Support for the Pakistan Democracy Act.png", date: "26 Nov 2024" },
];

const Resources = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (filepath) => {
        setSelectedImage(`${filepath}`);
        const modal = new window.bootstrap.Modal(document.getElementById('imageModal'));
        modal.show();
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title> First Pakistan Global </title>
            </Helmet>
            <Header />
            <section id="about-page">
                <div className="text-center">
                    <div
                        className="bg-common py-5"
                        style={{ backgroundImage: `url(${Banner})` }}
                    >
                        <div className="text-white fs-ss-68 py-4 py-md-5 my-md-5">
                            <div className="fw-700 text-uppercase">
                                <div className="fw-700">Resources</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                <div id="resources" className="container-fluid px-md-5">
                    <div className="row">
                        {resources.map((res, idx) => (
                            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                                <div className="card h-100 text-start rounded-0">
                                    {res.type === 'pdf' ? (
                                        <a
                                            href={`${res.filepath}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={res.thumbnail}
                                                alt={res.title}
                                                className="card-img-top img-fluid"
                                                style={{ "maxWidth": "100%", objectFit: "cover", objectPosition: "top center", height: "250px" }}
                                            />
                                        </a>
                                    ) : (
                                        <img
                                            src={`${res.filepath}`}
                                            alt={res.title}
                                            className="card-img-top img-fluid"
                                            style={{ cursor: 'pointer' }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#imageModal"
                                            onClick={() => setSelectedImage(res.filepath)}
                                        />
                                    )}
                                    <div className="card-body py-2 px-3 text-left bg-light bg-gradient">
                                        <div className="text-ss-primary fw-bold mt-2" style={{ fontSize: "12px" }}>{res.date}</div>
                                        <div className="fw-bold">{res.title}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Bootstrap Modal */}
                    <div
                        className="modal fade"
                        id="imageModal"
                        tabIndex="-1"
                        aria-hidden="true"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    {selectedImage && (
                                        <img
                                            src={selectedImage}
                                            className="img-fluid w-100"
                                            alt="Selected Preview"
                                        />
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={() => setSelectedImage(null)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default Resources;
